import React, { useContext, useEffect, useRef, useState } from 'react'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import workflowFormStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import waCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import textAreaStyles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { mediaTypeData, sendMediaPayload } from '../../../../../../models/flowBuilderTypes';
import { getDefaultValueOfSendMediaPayload } from '../../../flowBuilderConstants';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import Required from '../../../../../utility/required';
import { getFileTypeImgIcon, toCapitalizedCase } from '../../../../../../utils/constants';
import FileUpload from '../../../../../utility/fileUpload/fileUpload';
import { primaryColor, whiteColor } from '../../../../../../utils/colors';
import { progressInterface } from '../../../../contacts/createNewContactPopup';
import agent from '../../../../../../services/api';
import GlobalButton from '../../../../../utility/globalButton/button';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import IconsColor from '../../../../../utility/iconsColor';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { maxChars } from '../../../../channels/global/whatsapp/templates/utils';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import { handleKeyDownForFormatting } from '../../../../templatelibrary/constant';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface SendMediaPopupProps {
    actionData: any, 
    stepAction: any, 
    setFlagSendMediaPopup: React.Dispatch<React.SetStateAction<boolean>>,
} 

type combinedValueType = "mediaType" | "caption";
type combinedUpdateType = 
| { type: "mediaType", value:  mediaTypeData | null}
| { type: "mediaFile", value:  number | null}
| { type: "caption", value:  string }
| { type: "mime type", value: string }

const SendMediaPopup: React.FC<SendMediaPopupProps> = (props) => {
    
    const { actionData, stepAction, setFlagSendMediaPopup } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { onChangeCurrentActiveNodeConfig, onBlurOfFallBackOfBtnVar, nodes, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const mediaTypeData = useFlowBuilderStore((store) => store.mediaTypeData);
    const getMediaTypeApi = useFlowBuilderStore((store) => store.getMediaTypeApi);

    const [payload, setPayload] = useState<sendMediaPayload>(getDefaultValueOfSendMediaPayload(actionData));
    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState<progressInterface>({ filename: "", percent: 0 });

    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const revokeObjectUrlFromFiles = () => { // Call this function, everytime before set empty array in file state. (This will help to avoid memory leak)
        for(let i = 0; i < files?.length; ++i){
            const file = files[i];
            if(file?.blobUrl){
                URL.revokeObjectURL(file?.blobUrl);
            }
        }
    }

    const uploadFileToStorage = async (file: any) => {
        let formData = new FormData()
        formData.append(
            "file", file, file.name,
        )
        formData.append("chatbot_flag", "true");
        formData.append("private_file_flag", "false");

        let config = {
            onUploadProgress: (progressEvent: any) => {
                const { loaded, total } = progressEvent;
                var percent = Math.floor((loaded * 100) / total)
                setProgress({ ...progress, percent: percent, filename: file.name })
            }
        }

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            try {
            const res = await agent.uploadFile.post(formData, config);

            if (res.status) {
                file.isUploading = false;
                const responseData = res.data.data; 
                file.file_data = responseData;
                file.google_storage_id = responseData.google_storage_id;

                await setFiles((old: any) => {
                    const temp = [...old];
                    const fileType = file.name.split('.').pop();
                    const fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? "";

                    onChangeOfFields({ type: "mime type", value: `.${fileType}` });

                    temp.map((rr: any) => {
                        if (rr.google_storage_id === file.google_storage_id) {
                            rr.isUploading = false;
                            rr.file_data = responseData;
                            rr.google_storage_id = responseData.google_storage_id;
                            rr.previewImageSrc = fileTypeIconSrc;
                        }
                    });
                    return temp;
                });

                return responseData.google_storage_id;
            }
        } catch (err) {
            showError("Something went wrong!")
            revokeObjectUrlFromFiles();
            setFiles([]);
            console.error(err);
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
        return null; 
    }

    const uploadFileHandler = async (event: any) => {
        const file: any =  event.target.files[0];
        file.isUploading = true;
        
        const fileType = file.name.split('.').pop();
        const fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? "";
        file.previewImageSrc = fileTypeIconSrc;
        file.blobUrl = URL.createObjectURL(file);
        setFiles([file]);
        onChangeOfFields({ type: "mime type", value: `.${fileType}` });
    }

    const removeFileHandler = async (flagLoader: boolean, google_storage_id: number) => {
        if(flagLoader) setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        await agent.removeUploadedFile.delete(google_storage_id).then(async (res) => {
            if(!res.status){
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
        if(flagLoader) setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        revokeObjectUrlFromFiles();
        setFiles([]);
    }

    const onClickOfRemoveFile  = () => {
        revokeObjectUrlFromFiles();
        setFiles([]);
        onChangeOfFields({ type: "mediaFile", value: null });
    }

    const getMediaTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getMediaTypeApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getFileInfo = async (google_storage_id: number) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.getFileDetail.get(google_storage_id);
        if(!(res.status)){
            handleError(res);
        } else {
            const response = res?.data;
            let fileTypeChatbotId = response?.original_file_name.split('.').pop()
            let fileTypeIconSrcChatbot = getFileTypeImgIcon(fileTypeChatbotId) ?? ""
            let fileObj = {
                ...response, 
                file_data: response, 
                name: response?.original_file_name, 
                lastModified: response?.uploaded_at, 
                previewImageSrc: fileTypeIconSrcChatbot, 
                size: response?.file_size, 
                fileNewDesign: true
            }

            setFiles([fileObj]);
        }

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!mediaTypeData){
            getMediaTypeApiCall();
        }

        if(actionData?.google_storage_id && stepAction?.flag_saved_in_BE && files?.length == 0){
            getFileInfo(actionData?.google_storage_id);
        }
    }, []);

    const getMediaTypeById = (mediaTypeData: mediaTypeData[] | null, media_type_id: number | undefined) => {
        return mediaTypeData?.find((media) => media?.media_type_id == media_type_id) ?? null;
    }

    const getValueOfFields = (type: combinedValueType) => {
        switch(type){
            case "mediaType":
                return getMediaTypeById(mediaTypeData, payload?.media_type?.media_type_id);
            case "caption": 
                return payload?.caption ?? "";
            default: 
                return "";
        }
    }

    const onChangeOfFields = ({type, value}: combinedUpdateType) => {
        setPayload((prev) => {
            let newPayload = { ...prev };

            switch(type){
                case "mediaType":
                    if(!stepAction?.flag_saved_in_BE && newPayload?.google_storage_id){ // On change of media type, Remove file from storage, If media is still not saved in BE.
                        removeFileHandler(false, newPayload?.google_storage_id);
                    }
                    newPayload = {
                        ...newPayload,
                        media_type: value,
                        google_storage_id: null,
                    }
                    revokeObjectUrlFromFiles();
                    setFiles([]);
                    break;
                case "caption": 
                    if(value?.length <= maxChars) {
                        newPayload = {
                            ...newPayload,
                            caption: value,
                        }
                    }
                    break;
                case "mediaFile":
                    newPayload = {
                        ...newPayload, 
                        google_storage_id: value,
                    }
                    break;
                case "mime type":
                    newPayload = {
                        ...newPayload,
                        file_mime_type: getMediaTypeById(mediaTypeData, newPayload?.media_type?.media_type_id)?.file_mime_type?.find((mime) => mime?.file_extension == value) ?? null
                    }
                    break;
                default:
                    newPayload = prev;
            }

            return newPayload;
        })
    }

    const checkDisableSaveBtn = () => {
        if(isCurrentViewVersionPublished(currentActiveStaticWorkflow)) return true;
        if(!payload?.media_type?.media_type_id || files?.length == 0){
            return true;
        }

        return false;
    }

    const saveMediaFile = (storageId: number | null) => {
        if(stepAction?.flag_saved_in_BE && actionData?.google_storage_id != storageId){
            removeFileHandler(false, actionData?.google_storage_id);
        }
        const updatedObj = {
            media_type: payload?.media_type ?? null,
            google_storage_id: storageId ?? null,
            caption: payload?.caption ?? "",
            file_mime_type: payload?.file_mime_type ?? null,
        }
    
        const editExistingActionTypeObj = {
            updateType: "editExistingStepAction"
        }
    
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction?.chatbot_step_action_id, updatedObj, editExistingActionTypeObj); 
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction?.chatbot_step_action_id, updatedObj, editExistingActionTypeObj); 
        setFlagSendMediaPopup(false);
    }

    const onClickOfSaveBtn = async () => {
        let storageId = payload?.google_storage_id;
        if(!storageId){
            storageId = await uploadFileToStorage(files[0]);
        }
        saveMediaFile(storageId);
    }

    const joinMimeExtension = (extensions: string[]) => {
        return extensions?.join(", ") ?? "";
    }

    const getMediaTypeExtensions = () => {
        const mimeTypes = getMediaTypeById(mediaTypeData, payload?.media_type?.media_type_id)?.file_mime_type ?? [];

        const mediaTypeExtensions = mimeTypes.reduce((acc, { file_extension, mime_type }) => {
                if (!file_extension) return acc;

                acc.fileTypeExtensiontext.push(mime_type ? `${file_extension}, ${mime_type}` : file_extension);
                acc.fileTypeExtensionDescription.push(file_extension.replace(".", ""));

                return acc;
            },
            { fileTypeExtensiontext: [], fileTypeExtensionDescription: [] } as {
                fileTypeExtensiontext: string[];
                fileTypeExtensionDescription: string[];
            }
        );

        return {
            fileTypeExtensiontext: joinMimeExtension(mediaTypeExtensions.fileTypeExtensiontext), 
            fileTypeExtensionDescription: joinMimeExtension(mediaTypeExtensions.fileTypeExtensionDescription)
        }
    }

    const handleFormatting = (format: 'bold' | 'italic' | 'strikethrough') => {
        if(isCurrentViewVersionPublished(currentActiveStaticWorkflow)) return;

        const textarea = textareaRef.current;
        const start = (textarea as HTMLTextAreaElement).selectionStart;
        const end = (textarea as HTMLTextAreaElement).selectionEnd;
        const value = getValueOfFields("caption") as string ?? '';

        let formattedText = '';
        let cursorAdjustment = 0;

        switch (format) {
            case 'bold':
                formattedText = `*${value.substring(start, end)}*`;
                cursorAdjustment = 1;
                break;
            case 'italic':
                formattedText = `_${value.substring(start, end)}_`;
                cursorAdjustment = 1;
                break;
            case 'strikethrough':
                formattedText = `~${value.substring(start, end)}~`;
                cursorAdjustment = 1;
                break;
            default:
                formattedText = value.substring(start, end);
        }

        const newValue = value?.substring(0, start) + formattedText + value?.substring(end);

        onChangeOfFields({ type: "caption", value: newValue })

        setTimeout(() => {
            (textarea as HTMLTextAreaElement).setSelectionRange(start + cursorAdjustment, start + cursorAdjustment);
            (textarea as HTMLTextAreaElement).focus();
        }, 0);
    }

    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>
                        Send Media
                    </span>
                </Grid>
                <Grid item>
                    <Divider className={workflowFormStyles.resetVariableDivider} />
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={1}>
                        <Grid item xs={12}>
                            <Typography className={styles.createWorkflowLabelStyle}>
                                Media Type <Required />
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                className={`${contactStyles.contactFilterDropDowns} ${contactStyles.contactFilterDropdownsInPopup}`}
                                options={mediaTypeData || []}
                                getOptionLabel={(option) => toCapitalizedCase(option.media_type_name)}
                                value={getValueOfFields("mediaType") as mediaTypeData | null}
                                onChange={(_, value: mediaTypeData | null) => onChangeOfFields({ type: "mediaType", value: value })}
                                renderInput={(params) => <TextField {...params} placeholder='Select Media Type' />} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {(getValueOfFields("mediaType") as mediaTypeData) && 
                    <Grid item className={`${globalStyles.fullwidth}`}>
                        <Grid container gap={1}>
                            <Grid item xs={12}>
                                <Grid container direction={"column"}>
                                    <Grid item xs={12}>
                                        <Grid container gap={1} className={`${globalStyles.displayFlex}`}>
                                            <Grid item>
                                                <Typography className={`${styles.createWorkflowLabelStyle}`}>
                                                    File 
                                                    <Required />
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <GlobalTooltip
                                                    placement='top'
                                                    title="Only a single file upload is allowed. Please remove the existing file to upload another one."
                                                    arrow
                                                >
                                                    <Grid item className={`${globalStyles.displayFlex} ${globalStyles.clickable}`}>
                                                        <IconsColor fillColor={primaryColor} iconName="info" height={"16"} width={"16"} />
                                                    </Grid>
                                                </GlobalTooltip>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.tertiaryFontWeight} ${styles.allowedFileTypeText}`}>
                                        {`Allowed Formats: ${getMediaTypeExtensions()?.fileTypeExtensionDescription}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <FileUpload
                                    uploadedFileDetails={files}
                                    multipleFileAllow={false}
                                    fileSizeAllowed={500}
                                    fileTypeAllowed={getMediaTypeExtensions()?.fileTypeExtensiontext ?? ""}
                                    fileNumberAllowed={1}
                                    isDisabled={false}
                                    uploadFileHandler={(e) => uploadFileHandler(e)} 
                                    removeFileHandler={() => onClickOfRemoveFile()}
                                    flagLocallyStoreFile
                                    flagRemoveFileConfirmationPopup
                                />
                            </Grid>
                        </Grid>
                    </Grid>    
                }

                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={1}>
                        <Grid item xs={12}>
                            <Typography className={styles.createWorkflowLabelStyle}>
                                Caption
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {/* <TextField
                                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`} 
                                placeholder='Enter Caption'
                                value={getValueOfFields("caption")}
                                onChange={(e) => onChangeOfFields({ type: "caption", value: e.target.value })}
                            /> */}
                            <Grid container gap={1} direction={'column'}>
                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <textarea
                                        ref={textareaRef}
                                        value={getValueOfFields("caption") as string ?? ''}
                                        onChange={(e) => onChangeOfFields({ type: "caption", value: e.target.value })}
                                        placeholder="Enter Caption"
                                        className={`${contactStyles.textareaStyle} ${globalStyles.fullwidth}`}
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        onKeyDown={(e) => handleKeyDownForFormatting(e, handleFormatting)}
                                    />
                                </Grid>
                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                                        <Grid item>
                                            <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                                {`Characters: ${(getValueOfFields("caption") as string)?.length ?? 0} / ${maxChars}`}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Grid container alignItems={"center"} gap={{ xs: "10px", md: 2 }}>
                                                <Grid item>
                                                    <GlobalTooltip title={"Bold (Ctrl + B)"} placement="top" arrow>
                                                        <FormatBoldIcon className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`} onClick={() => handleFormatting('bold')} />
                                                    </GlobalTooltip>
                                                </Grid>
                                                <Grid item>
                                                    <GlobalTooltip title={"Italic (Ctrl + I)"} placement="top" arrow>
                                                        <FormatItalicIcon className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`} onClick={() => handleFormatting('italic')} />
                                                    </GlobalTooltip>
                                                </Grid>
                                                <Grid item>
                                                    <GlobalTooltip title={"Strikethrough (Ctrl + S)"} placement="top" arrow>
                                                        <StrikethroughSIcon className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`} onClick={() => handleFormatting('strikethrough')} />
                                                    </GlobalTooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>    
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item className={globalStyles.fullwidth} xs={12}>
                    <Grid container gap={"12px"} mt={2} mb={3} justifyContent={"center"} alignItems={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Cancel"
                                className='borderedButtonStyle'
                                sx={{ width: "120px" }}
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => setFlagSendMediaPopup(false)}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText="Save"
                                className='primaryButtonStyle'
                                sx={{ width: "120px" }} 
                                disabled={checkDisableSaveBtn()} 
                                onClick={() => onClickOfSaveBtn()}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default SendMediaPopup
